function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.156 11.531c.063.146.094.302.094.469s-.031.323-.094.469A10.56 10.56 0 0117.47 16.5 9.58 9.58 0 0112.25 18a9.83 9.83 0 01-3.625-.688 10.618 10.618 0 01-3.063-1.937 10.875 10.875 0 01-2.218-2.906c-.063-.146-.094-.302-.094-.469s.031-.323.094-.469c.875-1.666 2.104-3 3.687-4C8.615 6.511 10.354 6 12.25 6s3.635.51 5.219 1.531c1.583 1 2.812 2.334 3.687 4zM12.25 16.5c1.25 0 2.312-.438 3.187-1.313S16.75 13.25 16.75 12s-.438-2.313-1.313-3.188S13.5 7.5 12.25 7.5s-2.313.438-3.188 1.313S7.75 10.75 7.75 12s.438 2.313 1.313 3.188S11 16.5 12.25 16.5zm0-7.5c.833 0 1.542.292 2.125.875s.875 1.292.875 2.125c0 .813-.292 1.52-.875 2.125A2.893 2.893 0 0112.25 15c-.813 0-1.52-.292-2.125-.875-.583-.604-.875-1.313-.875-2.125 0-.27.042-.531.125-.781.25.187.542.281.875.281.417 0 .77-.146 1.062-.438s.438-.645.438-1.062c0-.333-.094-.625-.281-.875.25-.083.51-.125.781-.125z"
});

var SvgVisible = function SvgVisible(props) {
  return React.createElement("svg", _extends({
    fill: "currentColor",
    height: 24,
    width: 24
  }, props), _ref);
};

export default SvgVisible;